/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */

/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */

// @ts-ignore
// prettier-ignore
import { QueryStringArrayFormat, Method, RequestBodyType, ResponseBodyType, prepare } from 'yapi-to-typescript'
// @ts-ignore
// prettier-ignore
import type { RequestConfig, RequestFunctionRestArgs } from 'yapi-to-typescript'
// @ts-ignore
import request from '../../request';

type UserRequestRestArgs = RequestFunctionRestArgs<typeof request>;

// Request: 目前 React Hooks 功能有用到
export type Request<
  TRequestData,
  TRequestConfig extends RequestConfig,
  TRequestResult
> = (TRequestConfig['requestDataOptional'] extends true
  ? (requestData?: TRequestData, ...args: RequestFunctionRestArgs<typeof request>) => TRequestResult
  : (requestData: TRequestData, ...args: RequestFunctionRestArgs<typeof request>) => TRequestResult) & {
  requestConfig: TRequestConfig;
};

const mockUrl_0_0_0_0 = 'http://10.50.16.213:40001/mock/283' as any;
const devUrl_0_0_0_0 = '' as any;
const prodUrl_0_0_0_0 = 'http://127.0.0.1' as any;
const dataKey_0_0_0_0 = 'retdata' as any;

/**
 * @分类 [mock规则集管理↗](http://10.50.16.213:40001/project/283/interface/api/cat_2006)
 * @请求头 `POST /api/rulesSet`
 */
export interface ApiRulesSetPostRequest {
  /**
   * 规则集id
   */
  id?: number;
  /**
   * 是否保存。true:保存；false：草稿。
   */
  save?: boolean;
  /**
   * 规则集名称
   */
  name?: string;
  /**
   * 所属租户
   */
  mcid?: string;
  /**
   * 属性组
   */
  dataPropertyGroupId?: number;
  /**
   * 说明
   */
  detail?: string;
  /**
   * 数据值模板Id
   */
  dataRuleId?: number;
  /**
   * 步骤
   */
  step?: number;
  /**
   * 间隔时间规则id
   */
  uploadTimeRuleId?: number;
  /**
   * 延时时间规则id
   */
  dataTimeRuleId?: number;
  /**
   * 是否统一计算
   */
  unifiedCompute?: boolean;
  /**
   * Y轴倍率默认值，仅限数值型规则使用
   */
  yMagnificationValue?: number;
  /**
   * 累积量起始值默认值，仅限数值型规则使用
   */
  cumulativeStartValue?: number;
}

/**
 * @分类 [mock规则集管理↗](http://10.50.16.213:40001/project/283/interface/api/cat_2006)
 * @请求头 `POST /api/rulesSet`
 */
export type ApiRulesSetPostResponse = number;

/**
 * @分类 [mock规则集管理↗](http://10.50.16.213:40001/project/283/interface/api/cat_2006)
 * @请求头 `POST /api/rulesSet`
 */
type ApiRulesSetPostRequestConfig = Readonly<
  RequestConfig<
    'http://10.50.16.213:40001/mock/283',
    '',
    'http://127.0.0.1',
    '/api/rulesSet',
    'retdata',
    string,
    string,
    false
  >
>;

/**
 * @分类 [mock规则集管理↗](http://10.50.16.213:40001/project/283/interface/api/cat_2006)
 * @请求头 `POST /api/rulesSet`
 */
const apiRulesSetPostRequestConfig: ApiRulesSetPostRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/api/rulesSet',
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'apiRulesSetPost',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * @分类 [mock规则集管理↗](http://10.50.16.213:40001/project/283/interface/api/cat_2006)
 * @请求头 `POST /api/rulesSet`
 */
export const apiRulesSetPost = /*#__PURE__*/ (requestData: ApiRulesSetPostRequest, ...args: UserRequestRestArgs) => {
  return request<ApiRulesSetPostResponse>(prepare(apiRulesSetPostRequestConfig, requestData), ...args);
};

apiRulesSetPost.requestConfig = apiRulesSetPostRequestConfig;

/* prettier-ignore-end */
